import type {
  CouponsMeta,
  OrdersMeta,
  PresetsMeta,
  ProductsFilterMeta,
  SubscriptionsMeta,
  ClientsMeta,
  PostsMeta,
  SyncMeta,
  FileImportMeta,
} from '@/types'
import { UserRoleCodes } from '@/types'

import { clone } from '@/helpers'

export const DEFAULT_PRODUCTS_META: ProductsFilterMeta = {
  filters: [],
  sort: {
    field: 'id',
    direction: 'desc',
  },
  limit: 60,
  page: 1,
  total: 0,
}

export const DEFAULT_ORDERS_META: OrdersMeta = {
  filters: {
    hasCode: null,
    fromYear: null,
    fromMonth: null,
  },
  sort: {
    field: 'created_at',
    direction: 'desc',
  },
  options: {},
  limit: 50,
  page: 1,
  total: 0,
}

export const DEFAULT_SUBSCRIPTIONS_META: SubscriptionsMeta = {
  filters: {},
  sort: {
    field: 'created_at',
    direction: 'desc',
  },
  options: {},
  limit: 50,
  page: 1,
  total: 0,
}

export const DEFAULT_COUPONS_META: CouponsMeta = {
  filters: {
    isActive: null,
  },
  sort: {
    field: 'active',
    direction: 'desc',
  },
  limit: 50,
  page: 1,
  total: 0,
}

export const DEFAULT_CUSTOMER_META_SORT: ProductsFilterMeta['sort'] = {
  field: 'sort',
  direction: 'asc',
}

export const DEFAULT_CUSTOMER_META: ProductsFilterMeta = clone({
  ...DEFAULT_PRODUCTS_META,
  limit: 24,
  sort: DEFAULT_CUSTOMER_META_SORT,
})

export const DEFAULT_CUSTOMER_META_MOBILE: ProductsFilterMeta = clone({
  ...DEFAULT_CUSTOMER_META,
  limit: 12,
})

export const DEFAULT_PRESETS_META: PresetsMeta = {
  total: 0,
  active: 0,
}

export const DEFAULT_CLIENTS_META: ClientsMeta = {
  filters: {
    hasKeywords: null,
    hasRoles: [UserRoleCodes.Customer],
  },
  sort: {
    field: 'id',
    direction: 'desc',
  },
  limit: 24,
  page: 1,
  total: 0,
}

export const DEFAULT_POSTS_META: PostsMeta = {
  filters: {
    isActive: null,
  },
  sort: {
    field: 'sort',
    direction: 'asc',
  },
  limit: 24,
  page: 1,
  total: 0,
}
export const DEFAULT_GIFTCARDS_META = {
  filters: {
    active: null,
    isActive: null,
  },
  sort: {
    field: 'sort',
    direction: 'asc',
  },
  limit: 24,
  page: 1,
  total: 0,
}

export const DEFAULT_CUSTOMER_POSTS_META: PostsMeta = {
  filters: {
    isActive: true,
  },
  sort: {
    field: 'sort',
    direction: 'asc',
  },
  limit: 24,
  page: 1,
  total: 0,
}

export const DEFAULT_MOYSKLAD_SYNC_META: SyncMeta = {
  sort: {
    field: 'created_at',
    direction: 'desc',
  },
  limit: 24,
  page: 1,
  total: 0,
}

export const DEFAULT_IMPORT_META: FileImportMeta = {
  filters: {
    fromYear: null,
    fromMonth: null,
  },
  sort: {
    field: 'created_at',
    direction: 'desc',
  },
  options: {},
  limit: 24,
  page: 1,
  total: 0,
}
